import * as React from "react";
const SvgFiRrCodeCompare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-code-compare_svg__a)">
      <path
        fill="#062147"
        d="M24 5c0-2.206-1.794-4-4-4s-4 1.794-4 4a4.01 4.01 0 0 0 3 3.873V15c0 1.654-1.346 3-3 3h-3.369l2.203-2.203a.999.999 0 1 0-1.414-1.414l-2.541 2.541C10.33 17.472 10 18 10 19s.297 1.585.879 2.167l2.541 2.541a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-2.293-2.293H16c2.757 0 5-2.243 5-5V8.874A4.01 4.01 0 0 0 24 5m-4 2c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m-6.796.122A2.98 2.98 0 0 0 14.083 5c0-.802-.312-1.555-.879-2.121L10.663.338a.999.999 0 1 0-1.414 1.414L11.496 4H8C5.243 4 3 6.243 3 9v6.127A4.01 4.01 0 0 0 0 19c0 2.206 1.794 4 4 4s4-1.794 4-4a4.01 4.01 0 0 0-3-3.873V9c0-1.654 1.346-3 3-3h3.497L9.249 8.248a.999.999 0 1 0 1.414 1.414zM6 19c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-code-compare_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCodeCompare;
